const Pro = ({ marginValue = 0 }) => {
  return (
    <span
      style={{
        background: "#fe8004",
        color: "#fff",
        borderRadius: "5px",
        padding: "5px",
        fontSize: "10px",
        fontWeight: "800",
        marginLeft: marginValue,
      }}
    >
      PRO
    </span>
  );
};

export default Pro;
